/**
 * DetailRelatedContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail related container.
 */
const DetailRelatedContainer = styled.div.attrs({
  id: 'detailRelated',
})<React.CSSProperties>`
  position: relative;
  top: ${942 * Screen.widthRatio}px;
`;

export default DetailRelatedContainer;
